import { Component, inject } from '@angular/core';
import { SapPlantService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SapPlantCreateDto,
  SapPlantDto,
  SapPlantExcelDownloadDto,
  SapPlantUpdateDto,
} from '../proxy/controlling/dtos/sap-plant';
import { PLANT_CONFIG, PLANT_FIELDS } from './plant.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-plant',
  host: {
    'data-component-scope': 'controlling-plant',
  },
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SapPlantService, ConfirmationService],
  templateUrl: './plant.html',
  styleUrl: './plant.scss',
})
export class Plant extends BaseHierarchicalCrudComponent<
  SapPlantDto,
  SapPlantCreateDto,
  SapPlantUpdateDto,
  SapPlantExcelDownloadDto
> {
  service = inject(SapPlantService);
  config = PLANT_CONFIG;
  fields = PLANT_FIELDS;

  protected prepareUpdateDto(data: any, selected: SapPlantDto): SapPlantUpdateDto {
    return {
      name: data.name,
      code: data.code,
      locationId: data.locationId,
      companyCodeId: data.companyCodeId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Plant';
  }
}
